import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {RitornoPaginazione} from "../shared/models/RitornoPaginazione";
import {Prodotto} from "../Progetti/Models/Prodotto";
import {map} from "rxjs/operators";
import {ClassicType} from "../shared/models/ClassicType";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {AuthenticationService} from "../Login/_services/authentication.service";
import {ApiPathsService} from "../api-paths.service";
import {Materiale} from "./_Models/materiale";
import { Categorie } from '../Progetti/Models/Categorie';
import {SerialKey} from "../rma/_Models/serial-key";

@Injectable({
  providedIn: 'root'
})
export class ApiRestService {
  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService,
    private apiPaths: ApiPathsService,
  ) { }
  header() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${this.authenticationService.currentUserValue.access_token}`,
    });
  }
  headerforfile() {
    return new HttpHeaders({
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${this.authenticationService.currentUserValue.access_token}`,
    });
  }
  /**
   * Opzioni di default per le richieste HTTP
   */
  options() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.authenticationService.currentUserValue.access_token}`,
      }),
    };
  }

  GetParti(value): Observable<any> {
    return this.http.post<any>(
      `${this.apiPaths.getBaseAPI()}/prodotti/parti/list`,
      JSON.stringify(value),
      this.options()).pipe(map((data) => {
      const prodotti: any = new RitornoPaginazione<Prodotto[]>();
      prodotti.total = data.total;
      data.data.forEach(prodotto => prodotto.qty = 1)
      prodotti.data = data.data;
      prodotti.valore = data.valore;
      return prodotti;
    }));
  }
  GetPartiEcommerce(value: {id: number}): Observable<any> {
    return this.http.post<any>(
      `${this.apiPaths.getBaseAPI()}/prodotti/ecommerce/parti`,
      JSON.stringify(value),
      this.options()).pipe();
  }
  getPartiTypes(): Observable<ClassicType[]> {
    // var Result = new BehaviorSubject<ClassicType[]>([{id:1, label:"materiali"}])
    // return Result.asObservable();
    return this.http.get<ClassicType[]>(
      `${this.apiPaths.getBaseAPI()}/prodotti/parti/types`,
      this.options()).pipe(map((data) => {
        const elencoTipi: ClassicType[] = data ;
        return elencoTipi;
      })
    );
  }
  getAllParti(value): Observable<RitornoPaginazione<Materiale[]>> {
    return this.http.post<RitornoPaginazione<Materiale[]>>(
      `${this.apiPaths.getBaseAPI()}/prodotti/parti/listAll`,
      JSON.stringify(value),
      this.options()).pipe(map((data) => {
      const prodotti: RitornoPaginazione<Materiale[]> = new RitornoPaginazione<Materiale[]>();
      prodotti.total = data.total;
      prodotti.data = data.data;
      return prodotti;
    }));
  }

  getInfoParte(value): Observable<Materiale> {
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/prodotti/parti/get`,
      JSON.stringify(value),
      this.options()).pipe();
  }


  updateParti(value): Observable<any> {
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/prodotti/parti/update`,
      JSON.stringify(value),
      this.options()).pipe();
  }

  addParti(value): Observable<any> {
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/prodotti/parti/add`,
      JSON.stringify(value),
      this.options()).pipe();
  }
  deleteParti(value): Observable<any> {
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/prodotti/parti/delete`,
      JSON.stringify(value),
      this.options()).pipe();
  }
  restoreParti(value): Observable<any> {
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/prodotti/parti/restore`,
      JSON.stringify(value),
      this.options()).pipe();
  }

  GetCategorieList(classicType: ClassicType) {
    return this.http.get<Categorie[]>(`${this.apiPaths.getBaseAPI()}/prodotti/${classicType?.label?.toLowerCase()}/cat/list`,
      this.options()).pipe();
  }
  GetCategorieEcommerceList() {
    return this.http.get<Categorie[]>(`${this.apiPaths.getBaseAPI()}/prodotti/ecommerce/categorie`,
      this.options()).pipe();
  }
  CategorieListList(classicType: ClassicType, value: any) {
    return this.http.post<Categorie[]>(`${this.apiPaths.getBaseAPI()}/prodotti/${classicType?.label?.toLowerCase()}/cat/list/list`, JSON.stringify(value), this.options()).pipe();
  }
  AddCategorie(classicType: ClassicType, value: any) {
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/prodotti/${classicType?.label?.toLowerCase()}/cat/add`, JSON.stringify(value), this.options()).pipe();
  }
  EditCategorie(classicType: ClassicType, value: any) {
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/prodotti/${classicType?.label?.toLowerCase()}/cat/update`, JSON.stringify(value), this.options()).pipe();
  }
  DeleteCategorie(classicType: ClassicType, value: any) {
    return this.http.post<any>(`${this.apiPaths.getBaseAPI()}/prodotti/${classicType?.label?.toLowerCase()}/cat/delete`, JSON.stringify(value), this.options()).pipe();
  }
  getUnitaDiMisura(): Observable<ClassicType[]> {
    return this.http.get<ClassicType[]>(`${this.apiPaths.getBaseAPI()}/prodotti/um`, this.options()).pipe();
  }
  GetCategorieFullList() {
    return this.http.get<Categorie[]>(`${this.apiPaths.getBaseAPI()}/prodotti/schede/categorie`, this.options()).pipe();
  }
}
